<template>
    <DxDataGrid :data-source="dsCerinte" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="350" :height="370" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-count="1">
                <DxItem data-field="Cod" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Nume" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Descriere" :editor-options="{ height: 50 }"/>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Structura Cerinta
            </div>
        </template>

        <DxColumn data-field="Cod" caption="Cod"/>
        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="Descriere" caption="Descriere"/>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="350" height="370">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Structura Cerinta
            </div>
        </template>
        <DxForm :col-count="1" :data-dource="newCerinta">
            <DxSimpleItem data-field="Cod" :is-required="true">
                <template #default>
                    <DxTextArea :value="newCerinta.Cod" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newCerinta.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Descriere" :is-required="true">
                <template #default>
                    <DxTextArea :value="newCerinta.Descriere" @value-changed="onExplicatieValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template> 
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxNumberBox } from "devextreme-vue/number-box";
    import RU_StructuriCerinte from '@/services/RU/RU_StructuriCerinte';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox
        },
        data() {
            return {
                dsCerinte: {} as DataSource,
                addPopupVisible: false,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                newCerinta: {
                    Cod: '',
                    Nume: '',
                    Descriere: '',
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
            }
        },
        mounted() {
            this.dsCerinte = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `RU_StructuriCerinte`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onCodValueChanged(e: any) {
                this.newCerinta.Cod = e.value
            },
            onNumeValueChanged(e: any) {
                this.newCerinta.Nume = e.value
            },
            onExplicatieValueChanged(e: any) {
                this.newCerinta.Descriere = e.value
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newCerinta.Cod = ''
                this.newCerinta.Nume = ''
                this.newCerinta.Descriere = ''
            },
            onSaveAdd() {
                if (this.newCerinta.Cod.trim() === "" || !this.newCerinta.Cod) {
                    notify("Vă rog să completați câmpul obligatoriu 'Cod'!", "error", 3000)
                    return
                }

                if (this.newCerinta.Nume.trim() === "" || !this.newCerinta.Nume) {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                if (this.newCerinta.Descriere.trim() === "" || !this.newCerinta.Descriere) {
                    notify("Vă rog să completați câmpul obligatoriu 'Descriere'!", "error", 3000)
                    return
                }

                RU_StructuriCerinte.save(this.newCerinta).then((cerinta) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newCerinta = {
                        Nume: '',
                        Cod: '',
                        Descriere: ''
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                    notify("Datele exista deja!", 'error', 3000)
                })
            }
        }
    })
</script>   